import {NgModule} from '@angular/core';
import {Routes} from '@angular/router';
import {RouterModule} from '@angular/router';
import {AuthGuard} from '@auth0/auth0-angular';
import {MainPageComponent} from './features/main-page/main-page.component';
import {NotFoundComponent} from './layouts/not-found/not-found.component';
import {
  MainAppLayoutComponent,
  NavigationPoints,
  permissions,
} from './layouts/main/main-app-layout.component';
import {DefaultLayoutComponent} from './layouts/default/default-layout.component';
import {privilegeGuard} from './shared/guards/privilege.guard';
import {Entity} from './features/main-page/types';
import {ForbiddenComponent} from './layouts/forbidden/forbidden.component';

const routes: Routes = [
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'organizations', // TODO: do not forget to remove me
        title: 'Organizations - TCMR3',
        loadChildren: async () =>
          import(
            './features/organizations-generic/organizations-generic.module'
            ).then((m) => m.OrganizationsGenericModule),
        canActivate: [privilegeGuard],
        data: {
          privileges: permissions[NavigationPoints.ORGANIZATION],
        },
      },
      {
        path: 'banks-features',
        title: 'Bank Features - TCMR3',
        loadChildren: async () =>
          import('./features/banks-features/bank-features.module').then(
            (m) => m.BankFeaturesModule,
          ),
        canActivate: [privilegeGuard],
        data: {
          privileges: permissions[NavigationPoints.BANK_ADMIN],
        },
      },
      {
        path: 'dealer-admin',
        title: 'Dealer Admin - TCMR3',
        loadChildren: async () =>
          import('./features/dealer-admin/dealer-admin.module').then(
            (m) => m.DealerAdminModule,
          ),
        canActivate: [privilegeGuard],
        data: {
          privileges: permissions[NavigationPoints.DEALER_ADMIN],
        },
      },
      {
        path: 'vehicle-admin',
        title: 'Vehicle Admin - TCMR3',
        loadChildren: async () =>
          import('./features/vehicle-admin/vehicle-admin.module').then(
            (m) => m.VehicleAdminModule,
          ),
        canActivate: [privilegeGuard],
        data: {
          privileges: permissions[NavigationPoints.VEHICLE_ADMIN],
        },
      },
      {
        path: 'deal',
        title: 'Deal Admin - TCMR3',
        loadChildren: async () =>
          import('./features/deal/deal.module').then((m) => m.DealModule),
        canActivate: [privilegeGuard],
        data: {
          privileges: permissions[NavigationPoints.DEAL_ADMIN],
        },
      },
      {
        path: 'bank-admin',
        title: 'Bank Admin - TCMR3',
        loadChildren: async () =>
          import('./features/bank-admin/bank-admin.module').then(
            (m) => m.BankAdminModule,
          ),
        canActivate: [privilegeGuard],
        data: {
          privileges: permissions[NavigationPoints.BANK_ADMIN],
        },
      },
      {
        path: 'activity-admin',
        title: 'Activities Admin - TCMR3',
        loadChildren: async () =>
          import('./features/activity-admin/activity-admin.module').then(
            (m) => m.ActivityAdminModule,
          ),
        canActivate: [privilegeGuard],
        data: {
          privileges: permissions[NavigationPoints.ACTIVITY_ADMIN],
        },
      },
      {
        path: 'settings',
        title: 'Settings',
        loadChildren: async () =>
          import('./features/settings/settings.module').then(
            (m) => m.SettingsModule,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'iframes',
        title: 'IFrames - TCMR3',
        loadChildren: async () =>
          import('./features/iframes/iframes.module').then(
            (m) => m.IframesModule,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: '',
        component: MainAppLayoutComponent,
        children: [
          {
            path: '',
            component: MainPageComponent,
          },
          {
            path: 'forbidden',
            title: 'Forbidden',
            component: ForbiddenComponent,
          },
        ],
        canActivate: [AuthGuard],
      },

      {
        path: '**',
        component: NotFoundComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
